import { IServiceOrder } from "../interfaces/serviceOrder";
import axios from "./axios";
import { getConfig } from "../utils/sessionStorageUtils";

export const serviceOrders = async (requestData: any) => {
  try {
    const result = await axios.post(`/ServiceOrders`, requestData, getConfig());
    return result;
  } catch (e) {
    throw e;
  }
};

export const getServiceOrders = async (url: string) => {
  try {
    const result = await axios.get(`/ServiceOrders/${url || ""}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getServiceOrder = async (url: string) => {
  try {
    const result = await axios.get(url, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const changeStatus = async (id: string, status: number) => {
  try {
    const result = await axios.put(`/ServiceOrders/status-update`, { id, status}, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const deleteServiceOrder = async (serviceOrder: IServiceOrder) => {
  try {
    const result = await axios.delete(`/ServiceOrders/${serviceOrder?.id}`, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const exportServiceOrders = async (url: string) => {
  try {
    const result = await axios.get(`/Export/export-data-to-drive/service-orders/${url || ""}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};